// @ts-check

/**
 * GeoJSON data processing utilities.
 * Filters, transforms, and enriches GeoJSON features for map layers.
 * This is dependent on the structure of the geojson and content csv data. This is subject to change if either of those data structures change.
 */

/**
 * Filter GeoJSON features to only Point geometries (islands).
 * @param {Object} geoJson - Full GeoJSON FeatureCollection
 * @param {string|null} assignedIslandId - ID of the user's assigned island
 * @returns {Object} GeoJSON FeatureCollection with only Point features
 */
export function filterIslandFeatures(geoJson, assignedIslandId = null) {
  const islandFeatures = geoJson.features
    .filter((feature) => feature.geometry.type === "Point")
    .map((feature) => ({
      ...feature,
      properties: {
        ...feature.properties,
        isAssigned: feature.properties.mapbox_id === assignedIslandId
      }
    }));

  return {
    type: "FeatureCollection",
    features: islandFeatures
  };
}

/**
 * Match island feature with CSV data and merge properties.
 * @param {Object} feature - GeoJSON feature
 * @param {Array} islands - Array of island CSV records
 * @param {string} islandIdField - CSV field name for island ID
 * @returns {Object} Merged island data object
 */
export function matchIslandWithCsvData(feature, islands, islandIdField) {
  const csvIsland = islands.find(
    (island) => island[islandIdField] === feature.properties.mapbox_id
  );

  return csvIsland
    ? { ...feature.properties, ...csvIsland, type: "island" }
    : { ...feature.properties, type: "island" };
}
